<template lang="pug">
  .bin-document
    h6(:class='documentTitleClass') {{ documentTypeTranslation() }}
    ul.bin-document__link
      li(v-for='document in quantityDocumentsToggle()')
        div.cursor-pointer(
          @click='clickDocumentHandler(document, document_type)'
        )
          .d-flex.align-items-center
            img.mr-3.w-15.flex-shrink-0(:src='document.cover' alt='book cover' v-if='mustShowCover(document_type)' )
            .div
              .div(:class='documentItemClass')
                span(v-if='hasPage(document.page)', id='book_page') {{ `${t("components.bin_card.pagina")} ${document.page} - ${document.title}` }}
                span(v-else) {{ document.title }}
    button.bin-document__see-more-btn#document_list_see_more_btn(
      v-if='seeMoreButton' @click='seeTotalItemsToggle'
    ) {{ seeMoreLabel }}
</template>

<script>
import mixins from 'common/mixins'
import binCardMixin from 'common/mixins/bin_card_mixin'
import { trackEvent } from 'common/metrics'

export default {
  name: 'bin-card-document-list-vue',
  mixins: [mixins.translate, binCardMixin.requests],
  props: {
    documents: { type: Array, default: () => [] },
    document_type: {type: String, default: ''},
    fullView: { type: Boolean, default: false }
  },
  data() {
    return {
      seeMoreButton: true,
      is_collapsed: true
    }
  },
  methods: {
    showDocumentQuickView(id, document_type) {
      const documentID = id.toString()
      this.$emit('relatedDocumentData', documentID, document_type)
    },
    documentTypeTranslation() {
      let documentTypeParsed = this.document_type.replace(' ', '_')
      return I18n.t(`components.bin_card.document_types.${documentTypeParsed}`)
    },
    shortQuantityDocumentsShow() {
      const shortDocuments = this.documents.slice(0, this.numberOfResultsToPreview)
      return shortDocuments
    },
    seeTotalItemsToggle() {
      this.is_collapsed = !this.is_collapsed
    },
    showSeeMoreButtonToggle() {
      this.documents.length > this.numberOfResultsToPreview ? this.seeMoreButton = true : this.seeMoreButton = false
    },
    quantityDocumentsToggle() {
      return this.is_collapsed ?
        this.shortQuantityDocumentsShow() :
        this.documents
    },
    clickDocumentHandler(document, document_type){
      trackEvent(
        'BIN',
        `Click documento ${document_type}`,
        `${this.getCurrentView(this.fullView)}`
      )

      if(document_type=='biblioteca virtual'){
        this.openCloudLibraryDocument(document.id,document.page)
      }
      else{
        this.showDocumentQuickView(document.id,document_type)
      }
    },
    openCloudLibraryDocument(document_id, document_page){
      var cloudLibraryPath = gon.url_for.biblioteca_virtual_path.replace(':id',document_id)
      if (document_page)
        cloudLibraryPath =  `${cloudLibraryPath}?page=${document_page}`
      window.open(cloudLibraryPath,'_blank')
    },
    mustShowCover(docType) {
      return docType=='biblioteca virtual'
    },
    hasPage(document_page) {
      return document_page != null
    }
  },
  computed: {
    seeMoreLabel() {
      return this.is_collapsed ?
        I18n.t('components.bin_card.see_more') :
        I18n.t('components.bin_card.see_less')
    },
    documentTitleClass() {
      return this.fullView ? 'bin-document__title-full' : 'bin-document__title'
    },
    documentItemClass() {
      return this.fullView ? 'document-item-full' : 'document-item'
    },
    numberOfResultsToPreview() {
      return this.document_type=='biblioteca virtual' ? 3 : 5
    }
  },
  mounted() {
    this.showSeeMoreButtonToggle()
    this.quantityDocumentsToggle()
  }
}
</script>
